import React from 'react';
import styles from './CustomScrollIndicator.module.css';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow_down.svg';

const CustomScrollIndicator = () => {
    return (
        <div className={ styles.container_scrollDown }>
            <div className={ styles.scrollDown }>
                <div className={styles.arrow}>
                    <ArrowDown />
                </div>
            </div>
        </div>
    );
}

export default CustomScrollIndicator;